<template>
  <div class="module">
    <Spinner v-if="getLoading"></Spinner>

    <transition name="slide-fade">
      <div class="charts panel" v-if="!getLoading">
        <div class="filters">
          <a
            class="filter"
            @click.prevent="filterUpdate(7, true)"
            href="#"
            :class="{ active: dayFilter === 7 && !customSearch }"
          >Week</a>

          <a
            class="filter"
            @click.prevent="filterUpdate(30, true)"
            href="#"
            :class="{ active: dayFilter === 30 && !customSearch }"
          >Month</a>

          <a
            class="filter"
            href="#"
            @click="toggleCustomDateFilter"
            :class="{ active: customSearch }"
          >Custom</a>
        </div>

        <!-- Custom date filter -->
        <form
          class="custom-filter"
          v-if="showCustomDateFilter"
          @submit.prevent="filterCustomDates(true)"
        >
          <label for="custom-start-date">
            <span>Start date</span>
            <input
              type="date"
              name="custom-start-date"
              id="custom-start-date"
              v-model="customStartDate"
              required
              :min="oneYearAgo"
              :max="todayFormatted"
            >
          </label>

          <label for="custom-end-date">
            <span>End date</span>
            <input
              type="date"
              name="custom-end-date"
              id="custom-end-date"
              v-model="customEndDate"
              required
              :min="oneYearAgo"
              :max="todayFormatted"
            >
          </label>

          <input class="button button--standard" type="submit" value="Go">
        </form>

        <div class="date-change" v-if="!customSearch">
          <a @click.prevent="previousDates(true)" class="previous-dates" href="#">
            <img src="/img/arrow.svg" alt="previous date set">
          </a>

          <span>{{ formatDate(filterStartDate) }} - {{ formatDate(filterEndDate) }}</span>

          <a @click.prevent="nextDates(true)" class="next-dates" href="#" v-if="!isFilterEndToday">
            <img src="/img/arrow.svg" alt="next date set">
          </a>
        </div>
      </div>
    </transition>

    <transition name="slide-fade">
      <div class="entries" v-if="!getLoading">
        <details v-for="(day, index) in days" :key="index" :class="{ entry: day.entry }">
          <summary>
            {{ formatDate(day.date) }}
            <span
              class="need-log"
              v-if="!day.entry"
            >Log your {{ module | unMachine }}</span>
            <Arrow class="arrow" :color="day.entry ? '#000' : '#fff'"></Arrow>
          </summary>

          <div class="details-content">
            <component :is="currentModuleTable" :entry="day.entry" v-if="day.entry && !addNewEntry"></component>

            <!-- Load in the form for the module if there isn't an entry -->
            <component
              :is="currentModuleForm"
              @form-submit="formSubmit"
              @cancel-submit="cancelSubmit"
              :existingEntry="day.entry"
              :day="day"
            ></component>
          </div>
        </details>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapMutations, mapGetters } from "vuex";

import Spinner from "@/components/Spinner.vue";
import Arrow from "@/components/svg/Arrow.vue";

import Utility from "@/mixins/utility";

import { subDays } from "date-fns";
import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/auth";

export default {
  name: "Behavior",

  mixins: [Utility],

  components: { Spinner, Arrow },

  created() {
    // Check for user.
    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        // Set the user id,
        this.setUID(user.uid);

        // Set loading to true.
        this.modifyLoading(true);

        // Set logged in to true.
        this.modifyLoggedIn(true);

        // Grabs entries and days.
        this.updateDays(
          7,
          this.filterStartDate,
          this.filterEndDate,
          this.module,
          true
        );

        // Set the page title.
        this.changePageTitle(this.module);

        // Set page text.
        this.changePageIntroText("");

        // Disable loader.
        this.disableLoader(1000);
      } else {
        // Send the user to the auth page if they aren't logged in.
        this.$router.push("/auth");
      }
    });
  },

  methods: {
    ...mapMutations([
      "changePageTitle",
      "changePageIntroText",
      "modifyLoggedIn"
    ]),

    // Handle form submit.
    formSubmit(data, day) {
      this.addNewEntry = false;

      // Create a new entry.
      this.createLogEntry(this.module, data, day.date);
    },

    cancelSubmit() {
      this.addNewEntry = false;
    }
  },

  computed: {
    ...mapGetters(["getLoading"]),

    // Imports the matching module form fields.
    currentModuleForm() {
      return () => import(`../components/behavior/${this.module}/Form.vue`);
    },

    currentModuleTable() {
      return () => import(`../components/behavior/${this.module}/Table.vue`);
    }
  }
};
</script>
